import { Controller } from "@hotwired/stimulus"
import React from "react";
import { createRoot } from "react-dom/client";
import Wizard from "../components/Wizard.jsx";

export default class extends Controller {
  static values = {
    eventId: Number
  };
  connect() {
    document.addEventListener("turbo:load", () => {
      if (!this.root) {
        this.root = createRoot(this.element);
      }
      const props = {
        id: this.hasEventIdValue ? this.eventIdValue : null,
      };
      this.root.render(<Wizard {...props} />);
    });
  }
}